"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
const gearbox_1 = require("@busy-human/gearbox");
// Not sure this type is needed? Events are more specific to calendars, not meetings
var Events;
(function (Events) {
    function OptEventDefaults() {
        return {
            startTime: '',
            endTime: '',
            name: '',
            description: '',
            freeOrBusy: "free"
        };
    }
    class CollectionClass extends gearbox_1.CollectionEntity {
        defaults() {
            return OptEventDefaults();
        }
    }
    Events.CollectionClass = CollectionClass;
})(Events = exports.Events || (exports.Events = {}));
//# sourceMappingURL=index.js.map